import { createIntl, createIntlCache, IntlShape } from "react-intl";

import { displayLanguages } from "../utils/languages";
import en from "./languages/en.json";
import ja from "./languages/ja.json";
import zhCN from "./languages/zh-CN.json";
import zhTW from "./languages/zh-TW.json";
import vi from "./languages/vi.json";
import hi from "./languages/hi.json";

type Message = typeof en[number];

function convertToKeyValuePair(strings: Message[]) {
  return Object.fromEntries(strings.map((str) => [str.id, str.defaultMessage]));
}

export const messages = {
  en: convertToKeyValuePair(en),
  ja: convertToKeyValuePair(ja),
  "zh-CN": convertToKeyValuePair(zhCN),
  "zh-TW": convertToKeyValuePair(zhTW),
  vi: convertToKeyValuePair(vi),
  hi: convertToKeyValuePair(hi),
};

export type Language = keyof typeof messages;
export const defaultLanguage = displayLanguages.default;

const intlCache = createIntlCache();

export let intl: IntlShape;

export function makeIntl(language: any, messages: any) {
  intl = createIntl(
    {
      locale: language,
      messages: messages[language],
    },
    intlCache
  );
  return intl;
}

export function getBrowserLanguage() {
  return window?.navigator?.language || "en";
}

export function getAppLanguageByBrowserLanguage(): Language {
  const browserLanguage = getBrowserLanguage();

  if (/^en\b/.test(browserLanguage)) {
    return "en"; // English
  }

  if (/^hi\b/.test(browserLanguage)) {
    return "hi"; // Hindi
  }

  if (/^ja\b/.test(browserLanguage)) {
    return "ja"; // Japanese
  }

  if (/^vi\b/.test(browserLanguage)) {
    return "vi"; // Vietnamese
  }

  if (/^zh\b/.test(browserLanguage)) {
    return "zh-CN"; // Chinese Simplified
  }

  if (/^zh-TW/.test(browserLanguage)) {
    return "zh-TW"; // Chinese Traditional
  }

  return "en"; // English, as default
}
